<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
            name="purchase"
            to="/inventory/purchase"
            v-bind:num-pages="purchases_total"
            v-model="currentPage"
            v-bind:headers="headers"
            @change-pagination="changePagination"
            :data_loading="data_loading"
            v-bind:add_button_name="'add_purchase'"
            v-bind:data="purchases"
            view
            no-delete
            showSearch
            v-bind:search_text="search_text"
            v-bind:getData="update_purchases"
            v-bind:searchActivate="(state) => {search_text=state}"
            v-bind:setText="(text) => {search=text}"
        >
          <template #top>
            <v-combobox
                v-model="status"
                label="Status"
                v-bind:items="statusses"
                hide-details
                item-text="name"
                class="mx-1"
            />
            <v-combobox
                v-model="supplier"
                label="Supplier"
                v-bind:items="all_suppliers_"
                hide-details
                item-text="supplier_name"
                class="mx-1"
            />
            <v-combobox
                v-model="store"
                label="Store"
                v-bind:items="stores"
                hide-details
                item-text="name"
                class="mx-1"
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
import Purchases from "../../mixins/inventory/purchase";
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
const AllSuppliers = Object.assign(
    { ...Suppliers },
    {
      mounted() {
        this.get_all_suppliers();
      },
    }
);
export default {
  name: "InventoryPurchase",
  mixins: [Purchases, Services, AllSuppliers],
  data: () => ({
    page:1,
    // headers: [
    //   { text: "Purchase order", value: "p_order" },
    //   { text: "Date", value: "purchase_order_date" },
    //   { text: "Supplier", value: "supplier_name" },
    //   { text: "Store", value: "service_name" },
    //   { text: "Status", value: "status" },
    //   { text: "Received", value: "received" },
    //   { text: "Expected on", value: "expected_on" },
    //   { text: "Total", value: "total", align: "right" },
    // ],
    data: [],
    search_text: false,
    search: "",
  }),
  methods: {
    changePagination(page) {
      // this.purchases_page = page;
      // this.$store.commit("customers/updatePage", page)
      this.$store.commit("purchaseOrder/updatePagination", page)
      this.update_purchases(this.params);
    },
  },
  computed: {
    currentPage:{
      get(){
        return this.$store.state.purchaseOrder.page
      },
      set(val){
        this.$store.commit("purchaseOrder/updatePa", val)
      }
    },
    headers() {
      let headers = [
        { text: this.$t("purchase_order"), value: "p_order" , available: true},
        { text: this.$t("date"), value: "purchase_order_date" , available: true},
        { text: this.$t("supplier"), value: "supplier_name" , available: true},
        { text: this.$t("store"), value: "service_name" , available: true},
        { text: this.$t("status"), value: "status" , available: true},
        { text: this.$t("received"), value: "received" , available: true},
        { text: this.$t("expected_on"), value: "expected_on", available: true },
        { text: this.$t("type"), value: "type" }
      ]
      if(this.user_access && this.user_access.inv_purchase_orders_cost) {
        headers.push({ text: this.$t("total"), value: "total", align: "right" , available: true})
      }
      return headers
    }
  },
  mounted() {
    // for (const index in this.headers) {
    //   this.headers[index]["sortable"] = false;
    // }
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.update_purchases();
      },
    },
    supplier: {
      deep: true,
      handler() {
        this.update_purchases();
      },
    },
    status: {
      deep: true,
      handler() {
        this.update_purchases();
      },
    },
  },
};
</script>
